module.exports = __webpack_public_path__ + "img/excel.043341b2.png";